import { z } from 'zod';

import { clientSchema } from './Client';

export const clientListSchema = z.object({
  items: z.array(clientSchema),
  total: z.number(),
});

export type ClientListEntityApi = z.input<typeof clientListSchema>;

export type ClientListEntity = z.infer<typeof clientListSchema>;
